export class Breadcrumb {
  name: string;
  routerLink?: string;
}